import i18n from "@/i18n";
import { Expose, Type } from "class-transformer";

export class EnvironmentalResponseDTO {

  public uuid!: string;
  public year!: number;
  public status!: string;
}
export class InfractionDTO {

  private area!: number;
  private type!: string;
  private description!: string;
  
  @Expose({ name: "crop_area" })
  private cropArea!: number;
  
  @Expose({ name: "crop_label" })
  private cropLabel!: string;
  
  @Expose({ name: "crop_type" })
  private cropType!: string;

  get cropTypeTranslated() {
    return i18n.t(`crop-types.${this.cropType}`).toString();
  }

  get infractionsTypeTranslated() {
    return i18n.t(`environmental.infractions-type.${this.type}`).toString();
  }

  get infractionAreaPercentage() {
    return parseFloat((this.area / this.cropArea * 100).toFixed(0));
  }

  get formattedCropArea() {
    return parseFloat(this.cropArea.toFixed(2));
  }

  get formattedArea() {
    return parseFloat(this.area.toFixed(2));
  }
  
}

export class EnvironmentalDTO {

  public status!: string;

  @Expose({ name: "analysis_uuid" })
  public analysisUuid!: string;

  public year!: number;

  @Expose({ name: "environmental_analysis_uuid" })
  public environmentalAnalysisUuid!: string;

  @Expose({ name: "geojson_intersect_url" })
  public geojsonIntersectUrl!: string;

  @Expose({ name: "image_intersect_url" })
  public imageIntersectUrl!: string;

  @Type(() => InfractionDTO)
  public infractions!: InfractionDTO[];

  get isProcessing() {
    return !this.notCreated && (this.status === "PROCESSING" || this.status === 'WAITING');
  }

  get hasInfractions() {
    return !this.notCreated && this.infractions != null && this.infractions.length > 0;
  }

  get notCreated() {
    return this.environmentalAnalysisUuid == null;
  }

  get isFinished() {
    return !this.notCreated && this.status === "FINISHED"
  }
 
}
